import { ComposedTheme, createUseStyles } from '@glu/theming';

export const styles = ({ dataComponents: { exportIcon } }: ComposedTheme) => {
  return {
    popover: {
      margin: 0,
      padding: [8, 0],
      minWidth: 150,
    },
    menuButton: {
      fontFamily: exportIcon.menuButton.text.font.fontFamily,
      display: 'block',
      color: exportIcon.menuButton.text.color,
      padding: 8,
      lineHeight: '24px',
      width: '100%',
      textAlign: 'left',
      '&:focus, &:hover': {
        textDecoration: 'none',
      },
      '&:hover': {
        backgroundColor: exportIcon.menuButton.hoverColor,
      },
    },
  };
};

export default createUseStyles(styles);
